import { render, staticRenderFns } from "./add-expense.vue?vue&type=template&id=6a08018e&scoped=true&"
import script from "./add-expense.vue?vue&type=script&lang=js&"
export * from "./add-expense.vue?vue&type=script&lang=js&"
import style0 from "./add-expense.vue?vue&type=style&index=0&id=6a08018e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a08018e",
  null
  
)

export default component.exports